// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__YWBwy","requiredAsterisk":"Info_requiredAsterisk__2J1jb"};